const STORAGE_KEY = 'near_location_active';

export function loadActiveLocation() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const lat = Number(parsed?.lat);
    const lng = Number(parsed?.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return {
      lat,
      lng,
      name: String(parsed?.name || '').trim(),
      city: String(parsed?.city || '').trim(),
      source: parsed?.source === 'gps' ? 'gps' : 'manual',
      updatedAt: parsed?.updatedAt || null,
    };
  } catch {
    return null;
  }
}

export function saveActiveLocation(location) {
  const lat = Number(location?.lat);
  const lng = Number(location?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  const payload = {
    lat,
    lng,
    name: String(location?.name || '').trim(),
    city: String(location?.city || '').trim(),
    source: location?.source === 'gps' ? 'gps' : 'manual',
    updatedAt: Date.now(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  return payload;
}

export function clearActiveLocation() {
  localStorage.removeItem(STORAGE_KEY);
}
